import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminApi } from './useAdminApi';

const BASE = '/api/admin/shop-owners';

export const useShopOwners = () => {
    const navigate = useNavigate();
    const { request, notify, hasAccess, user } = useAdminApi();
    const [data, setData] = useState({ owners: [], total: 0, page: 1, pageSize: 20, summary: null });
    const [isLoading, setIsLoading] = useState(false);
    const [query, setQuery] = useState({ q: '', status: '', page: 1 });

    useEffect(() => {
        if (!user) navigate('/login');
        else if (!hasAccess('shop-owners')) navigate('/');
    }, [user, hasAccess, navigate]);

    const load = useCallback(async () => {
        setIsLoading(true);
        const json = await request(BASE, { query });
        if (json) setData(json);
        setIsLoading(false);
    }, [request, query]);

    useEffect(() => {
        if (user?.token && hasAccess('shop-owners')) load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user?.token, query]);

    const act = async (path, options, success) => {
        const json = await request(path, options);
        if (json) {
            notify(success);
            load();
        }
        return json;
    };

    return {
        ...data,
        isLoading,
        query,
        setQuery,
        reload: load,
        toggleBan: (owner) => act(`${BASE}/${owner._id}/ban`, { method: 'PATCH' }, owner.isBanned ? 'تم رفع الحظر' : 'تم حظر الحساب'),
        adjustBalance: (id, amount) => act(`${BASE}/${id}/balance`, { method: 'POST', body: { amount } }, 'تم تعديل الرصيد'),
        deleteOwner: (id, reason) => act(`${BASE}/${id}`, { method: 'DELETE', body: { reason } }, 'تم حذف الحساب'),
        reactivateOwner: (id) => act(`${BASE}/${id}/reactivate`, { method: 'PATCH' }, 'تمت إعادة تفعيل الحساب'),
    };
};

export default useShopOwners;
